import React, { Component } from 'react';
import Modal from 'react-modal';
import { withRouter } from 'react-router-dom';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';
import SalesTargetUpdateModalUI from './SalesTargetUpdateModalUI';

class SalesTargetUpdateModalSF extends Component {
  constructor(props) {
    super(props);

    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      salesTargetId: '',
      salesTargetIdError: null,
      userId: '',
      userIdError: null,
      month: '',
      monthError: null,
      year: '',
      yearError: null,
      noOfContacts: '',  
      noOfContactsError: null,  
      newLeadTarget: '',
      newLeadTargetError: null,
      newDisbTarget: '',
      newDisbTargetError: null,
      numberOfCustomers: '',
      numberOfCustomersError: null,
      contactsAchieved: '',
      contactsAchievedError: null,
      newLeadAchieved: '',
      newLeadAchievedError: null,
      newDisbAchieved: '',
      newDisbAchievedError: null,
      customersAchieved: '',
      customersAchievedError: null,
      userName: null,
      monthName: null
    };
  }

  render() {
    return (
      <SalesTargetUpdateModalUI
        context={this.props.context}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        onSubmit={this.onSubmit}
        onCancelClick={this.onUpdateSalesTargetCancel}
        updateMode={this.props.salesTargetUpdateMode}
        submitted={this.state.submitted}
        //
        userName={this.state.userName}
        monthName={this.state.monthName}
        //
        salesTargetId={this.state.salesTargetId}
        userId={this.state.userId}
        month={this.state.month}
        year={this.state.year}
        //
        noOfContacts={this.state.noOfContacts}  
        onNoOfContactsChange={(event) => this.setState({ noOfContacts: event.target.value })}  
        noOfContactsError={this.state.noOfContactsError}  
        setNoOfContactsError={(error) => this.setState({ noOfContactsError: error })}  
        //
        newLeadTarget={this.state.newLeadTarget}
        onNewLeadTargetChange={(event) => this.setState({ newLeadTarget: event.target.value })}
        newLeadTargetError={this.state.newLeadTargetError}
        setNewLeadTargetError={(error) => this.setState({ newLeadTargetError: error })}
        //
        newDisbTarget={this.state.newDisbTarget}
        onNewDisbTargetChange={(event) => this.setState({ newDisbTarget: event.target.value })}
        newDisbTargetError={this.state.newDisbTargetError}
        setNewDisbTargetError={(error) => this.setState({ newDisbTargetError: error })}
        //
        numberOfCustomers={this.state.numberOfCustomers}
        onNumberOfCustomersChange={(event) => this.setState({ numberOfCustomers: event.target.value })}
        numberOfCustomersError={this.state.numberOfCustomersError}
        setNumberOfCustomersError={(error) => this.setState({ numberOfCustomersError: error })}
         //
         contactsAchieved={this.state.contactsAchieved}
         onContactsAchievedChange={(event) => this.setState({ contactsAchieved: event.target.value })}
         contactsAchievedError={this.state.contactsAchievedError}
         setContactsAchievedError={(error) => this.setState({ contactsAchievedError: error })}
         //
         newLeadAchieved={this.state.newLeadAchieved}
         onNewLeadAchievedChange={(event) => this.setState({ newLeadAchieved: event.target.value })}
         newLeadAchievedError={this.state.newLeadAchievedError}
         setNewLeadAchievedError={(error) => this.setState({ newLeadAchievedError: error })}
         //
         newDisbAchieved={this.state.newDisbAchieved}
         onNewDisbAchievedChange={(event) => this.setState({ newDisbAchieved: event.target.value })}
         newDisbAchievedError={this.state.newDisbAchievedError}
         setNewDisbAchievedError={(error) => this.setState({ newDisbAchievedError: error })}
         //
         customersAchieved={this.state.customersAchieved}
         onCustomersAchievedChange={(event) => this.setState({ customersAchieved: event.target.value })}
         customersAchievedError={this.state.customersAchievedError}
         setCustomersAchievedError={(error) => this.setState({ customersAchievedError: error })}
      />
    );
  }

  componentDidMount() {
    Modal.setAppElement('body');
  }

  componentDidUpdate(prevProps) {
    if (!prevProps || !this.props.salesTarget) return;

    if (prevProps.salesTarget && prevProps.salesTarget.salesTargetId === this.props.salesTarget.salesTargetId) return;

    let fullName = this.props.salesTarget.firstName + " " + this.props.salesTarget.lastName;

    let eYear, eMonth;
    [eYear, eMonth] = this.props.salesTarget.yearMonth.split('-');

    const monthNames = {
      '01': 'Jan',
      '02': 'Feb',
      '03': 'Mar',
      '04': 'Apr',
      '05': 'May',
      '06': 'Jun',
      '07': 'Jul',
      '08': 'Aug',
      '09': 'Sep',
      '10': 'Oct',
      '11': 'Nov',
      '12': 'Dec'
    };

    let monthh = monthNames[eMonth];

    this.setState({
      salesTargetId: this.props.salesTarget.salesTargetId,
      userId: this.props.salesTarget.userId,
      userName: fullName,
      year: eYear,
      month: eMonth,
      monthName: monthh,
      noOfContacts: this.props.salesTarget.noOfContactsF,
      newLeadTarget: this.props.salesTarget.newLeadTargetF,
      newDisbTarget: this.props.salesTarget.newDisbTargetF,
      numberOfCustomers: this.props.salesTarget.numberOfCustomersF,
      contactsAchieved: this.props.salesTarget.contactsAchievedF,
      newLeadAchieved: this.props.salesTarget.newLeadAchievedF,
      newDisbAchieved: this.props.salesTarget.newDisbAchievedF,
      customersAchieved: this.props.salesTarget.customersAchievedF,
    });
  }

  onUpdateSalesTargetCancel = () => {
    this.setState({
      successMsg: null,
      submiited: false,
      errorList: null,
      userId: '',
    });
    this.props.onUpdateSalesTargetCancel();
  };

  onSubmit = () => {
    if (this.state.submitted) return;

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true,
    });

    RestApiUtils.put(
      this.props.context,
      `/api/su/sales/targets/users/${this.state.salesTargetId}`,
      this.onSubmitCallback,
      {
        noOfContacts: this.state.noOfContacts,
        newLeadTarget: this.state.newLeadTarget,
        newDisbTarget: this.state.newDisbTarget,
        numberOfCustomers: this.state.numberOfCustomers,
        contactsAchieved: this.state.contactsAchieved,
        newLeadAchieved: this.state.newLeadAchieved,
        newDisbAchieved: this.state.newDisbAchieved,
        customersAchieved: this.state.customersAchieved,
      }
    );
  };

  onSubmitCallback = (response) => {
    let errorList = [];
    if (response && response.errorList) {
      response.errorList.forEach((error) => {
        errorList.push(error.message);
      });
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false,
    });

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null });
        this.onUpdateSalesTargetCancel();
        this.props.onRefreshClick();
      }, 2000);
    }
  };

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList });
  };
}

export default withRouter(SalesTargetUpdateModalSF);
